import { bildiriyor, type StokKaynak } from './useStokVerisi';

/**
 * G4b/final-fix F-5 — kapsam notu (§S1/§4.5 mekanizması). SermayeBlok/AkisBlok'un ŞUBE için,
 * KayipBlok'un "Fire nerede" kartının KATEGORİ için taşıdığı sabit `sube !== null` koşulu bu dosyaya
 * taşındı: not artık ds'in GERÇEK bildirimine bağlı, yazılış anındaki (bugün doğru olan) bir varsayıma
 * değil. Bir ds ileride ilgili parametreyi kazanırsa (ör. 990043 `@LOKASYON` bildirmeye başlarsa) not
 * kendiliğinden kaybolur — kod değişikliği gerekmez (bkz. kapsam.test.ts, sahte kaynağa bildirim
 * ekleyip notun kaybolduğunu gösterir).
 *
 * Bir ds ya HİÇ göndermez (undefined kaynak — kart zaten görünmez) ya da bildirmiyorsa parametre
 * `stokParametreleri`/`ekstraSuzulmus` tarafından zaten süzülüyor (useStokVerisi.ts); bu dosya yalnız
 * KULLANICIYA GÖRÜNÜR notu türetir, sorguya hiçbir şey göndermez.
 */

/** Verilen kaynaklardan, `parametreAdi`yi BİLDİRMEYENLERİ döndürür (`undefined` kaynaklar elenir). */
export function suzgecDisiKaynaklar(
  kaynaklar: (StokKaynak | undefined)[],
  parametreAdi: string,
): StokKaynak[] {
  return kaynaklar.filter((k): k is StokKaynak => !!k && !bildiriyor(k, parametreAdi));
}

/**
 * Kapsam notu görünsün mü? YALNIZ (a) ilgili süzgeç DOLU ise (`suzgecDegeri !== null`) VE (b) verilen
 * kaynaklardan EN AZ BİRİ o parametreyi bildirmiyorsa. İkisi de gerçekleşmezse (süzgeç boş, ya da
 * tüm kaynaklar zaten bildiriyor) not YOKTUR — sessizce "firma geneli"/"tüm kategoriler" göstermek
 * yerine kullanıcıya söylenir, ama süzgeç zaten etkiliyse gereksiz gürültü yapılmaz.
 */
export function kapsamNotuGorunsunMu(
  kaynaklar: (StokKaynak | undefined)[],
  parametreAdi: string,
  suzgecDegeri: string | null,
): boolean {
  if (suzgecDegeri === null) return false;
  return suzgecDisiKaynaklar(kaynaklar, parametreAdi).length > 0;
}
